import { Routes, Route, Navigate } from 'react-router-dom';
import RelatoriosPage from './pages/Relatorios';
import AppProvider from './app-provider';

export default function App() {
  return (
    <AppProvider>
      <Routes>
        <Route path="/relatorios" element={<RelatoriosPage />} />
        <Route path="*" element={<Navigate to="/relatorios" replace />} />
      </Routes>
    </AppProvider>
  );
}
